<div class="d-flex mx-0 flex-column flex-md-row justify-contet-between p-white border-bottom secondaryMenu px-4 py-3">
    <div class="d-flex flex-column col">
        <h3 class="mt-0 mb-1">Create Job Chain</h3>
        <p-breadcrumb [model]="items"></p-breadcrumb>
    </div>
    <div class="d-flex justify-content-start justify-content-md-end col mt-2 mt-md-0">
        <button pButton pRipple type="button" label="Discard Request" class="p-button-outlined p-button-danger me-3"></button>
        <button pButton pRipple type="button" label="Save Request" class="p-button-outlined me-3"></button>
        <button pButton type="button" icon="pi pi-check" label="Send Request" iconPos="left"></button>
    </div>
</div>

<div class="row mx-0 createJobChain">
    <div class="col-12 col-sm-12 col-md-4 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <h4 class="mt-0 mb-4">Add Transactions</h4>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Name</label>
                <input type="text" placeholder="Purchasing Flow" pInputText> 
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Description</label>
                <textarea rows="5" cols="30" pInputTextarea placeholder="Enter Description"></textarea>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Company</label>
                <p-dropdown placeholder="Select Company"  optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-column mb-4">
                <label class="mb-2">Operation Group</label>
                <p-dropdown placeholder="None"  optionLabel="name"></p-dropdown>
            </div>
            <div class="d-flex flex-row mb-4 align-items-center justify-content-between">
                <label class="mb-0">Transaction</label>
                <button pButton pRipple type="button" label="Search Transactions" class="p-button-secondary p-button-text" icon="pi pi-search" iconPos="left" ></button>
            </div>
            <div>
                <p-accordion>
                    <p-accordionTab header="Purchasing" [selected]="true">
                        <div *ngFor="let product of availableProducts" class="d-flex flex-column">
                            <div class="product-item" pDraggable="products" (onDragStart)="dragStart(product)">
                                <div class="d-flex flex-row bg-light justify-content-md-between p-2 align-items-center mb-2">
                                    <p class="mb-0 mt-0"><span class="me-2"><i class="pi pi-bars"></i></span>Purchase Request</p>
                                </div>
                                    
                            </div>
                        </div>
                    </p-accordionTab>
                </p-accordion>
            </div>
        </div>
    </div>
    <div class="col col-md-8 px-0">
        <div class="m-3 p-white shadow-sm bg-aqua p-3">
            <div  pDroppable="products" (onDrop)="drop()">
                    <p-table [autoLayout]="true"  [value]="selectedProducts">
                        <ng-template pTemplate="body" let-product let-index="rowIndex">
                            <tr [pReorderableRow]="index">
                                <td style="width: 48px; text-align: center; padding-bottom: 12px;">
                                    <span class="pi pi-bars" [pReorderableRowHandle]="index"></span>
                                </td>
                                <td class="text-left">
                                    Purchase Request
                                </td>
                                <td style="width: 48px; text-align: center; padding-bottom: 12px;">
                                    <span class="pi pi-trash"></span>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                <div class="p-3 dropItemMessage">
                    Drag and Drop Jobs from the Panel  
                </div>
            </div>
        </div>





        
    </div>
</div>

    


           
            